import React, { useEffect, useState } from 'react';
import PaginatedTable from '../PaginatedTable';
import { useNavigate } from 'react-router-dom';
import { collection, getDocs, query, orderBy, limit, startAfter } from 'firebase/firestore';
import { db } from '../../firebase';
import Spinner from '../Spinner';

export default function UserRolesList({ organizationId }) {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(true);

  const [opts, setOpts] = useState({
    itemsPerPage: 10,
    sortBy: 'id',
    sortOrder: 'asc',
    persistent: true,
    uid: 'user-roles-list'
  });

  const columns = [
    {
      name: 'ID',
      sortKey: 'id',
      render: (item) => item.id,
    },
    {
      name: 'Name',
      sortKey: 'name',
      render: (item) => item.name,
    },
  ];

  useEffect(() => {
    const fetchUserRoles = async () => {
      setLoading(true);
      try {
        const path = `organizations/${organizationId}/user-roles`;
        const rolesCollection = collection(db, path);

        let q = query(rolesCollection, orderBy(opts.sortBy, opts.sortOrder), limit(opts.itemsPerPage));

        if (currentPage > 0) {
          const prevDocsSnapshot = await getDocs(
            query(rolesCollection, orderBy(opts.sortBy, opts.sortOrder), limit(currentPage * opts.itemsPerPage))
          );
          const lastVisible = prevDocsSnapshot.docs[prevDocsSnapshot.docs.length - 1];
          q = query(rolesCollection, orderBy(opts.sortBy, opts.sortOrder), startAfter(lastVisible), limit(opts.itemsPerPage));
        }

        const snapshot = await getDocs(q);
        const rolesData = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

        setRows(rolesData);
        setTotalCount((await getDocs(rolesCollection)).size);
      } catch (error) {
        console.error('Error fetching user roles:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserRoles();
  }, [currentPage, opts, organizationId]);

  const setPage = (page) => setCurrentPage(page);
  const setOptions = (newOpts) => {
    setOpts((prev) => ({ ...prev, ...newOpts }));
    setCurrentPage(0); 
  };

  if (loading) {
    return <Spinner />;
  }

  return (
    <PaginatedTable
      className="is-fullwidth is-hoverable"
      columns={columns}
      rows={rows}
      currentPage={currentPage}
      totalCount={totalCount}
      loading={loading}
      setPage={setPage}
      opts={opts}
      setOpts={setOptions}
      onRowClick={(item) =>
        navigate(`/user-roles/${item.id}?organizationId=${organizationId}`)
      }
    />
  );
}
